<template>
  <div class="NotificationSettingsContainer">
    <!-- Notification Header für jede Route -->
    <div class="displayflex flexbetween cursor-pointer" @click="extended = !extended">
      <div class="displayflex flexbetween" style="width:100%">
        <div class="selfAlignCenter fontweight600">{{route.titel}}</div>
        <ToggleButton
          class="selfAlignCenter"
          :toCheck="route.notification"
          :index="index"
          @input="setBenachrichtigung(route, ...arguments)"
          :disabled="isLoading"
        />
      </div>
      <SVGIcon
        class="marginleft20 selfAlignCenter"
        :name="extended ? 'settings_filled' : 'settings'"
        size="little"
      />
    </div>

    <!-- Notification Einstellung für jede Route -->
    <div v-if="extended" class="margintop15 colorLightGrey">
      <!-- UHRZEIT AUSWAHL -->
      <div class="displayflex">
        <SVGIcon name="uhrzeit"/>
        <div class="marginleft15 selfAlignCenter">Benachrichtigungszeitraum</div>
      </div>
      <div class="displayflex flexbetween">
        <div class="selfAlignCenter">von</div>
        <TimePicker class="timepicker colorDarkGrey" v-model="localRoute.zeitVon" :show-meridian="false" :min-step="15"/>
        <div class="selfAlignCenter">bis</div>
        <TimePicker class="timepicker colorDarkGrey" v-model="localRoute.zeitBis" :show-meridian="false" :min-step="15"/>
      </div>
      <!-- AUSWAHL DER TAGE -->
      <div class="displayflex">
        <SVGIcon name="kalender"/>
        <div class="marginleft15 selfAlignCenter">an folgenden Tagen</div>
      </div>
      <div class="displayflex flexbetween margintop15">
        <div
          v-for="(wochentag,index) of Object.keys(localRoute.wochentage)"
          :key="index"
          :class="['wochentag borderGrey cursor-pointer textcenter', localRoute.wochentage[wochentag] ? 'backgroundBlue colorWhite' : 'colorDarkGrey']"
          @click="changeWochentag(wochentag)"
        >{{wochentag}}</div>
      </div>

      <!-- Benachrichtigungsintervall -->
      <div class="displayflex margintop15">
        <SVGIcon name="intervall"/>
        <div class="marginleft15 selfAlignCenter">Benachrichtigungsintervall</div>
      </div>
      <div class="displayflex margintop15">
        <div
          v-for="interval of intervalle"
          :key="interval"
          :class="['wochentag borderGrey cursor-pointer textcenter', localRoute.notificationInterval === interval ? 'backgroundBlue colorWhite' : 'colorDarkGrey']"
          style="width:36px; height:36px;margin-right:10px;"
          @click="changeInterval(interval)"
        >{{interval}}</div>
        <div class="selfAlignCenter">Min.</div>
      </div>

      <div
        class="speichern displayflex  colorBlue fontweight600 margintop20 borderRadius30 borderBlue borderStyleSolid borderWidth1 cursor-pointer"
        @click="emitNotificationEinstellungen"
      >
        <SVGIcon class="marginleft15" size="little" name="settings_filled"/>
        <div class="selfAlignCenter marginleft15">Einstellungen speichern</div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleButton from "../CoreComponents/ToggleButton.vue";
import TimePicker from "../CoreComponents/TimePicker/TimePicker.vue";


export default {
  name: "NotificationSettings",
  components: {
    ToggleButton,
    TimePicker
  },
  props: ["route", "index"],
  data: function() {
    if (!this.route.notificationInterval) {
      this.route.notificationInterval = 5;
    }
    const localRoute = JSON.parse(JSON.stringify(this.route));
    return {
      extended: false,
      localRoute: localRoute,
      intervalle: [5, 10, 15, 20]
    };
  },
  mounted() {
    this.checkTimeFormat();
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    }
  },
  methods: {
    setBenachrichtigung(route, checked) {
      this.extended = checked;
      route.notification = checked;
      this.$emit("notificationChanged", route);
    },
    emitNotificationEinstellungen() {
      this.$emit(
        "save",
        JSON.parse(
          JSON.stringify({
            zeitVon: this.localRoute.zeitVon,
            zeitBis: this.localRoute.zeitBis,
            wochentage: this.localRoute.wochentage,
            notificationInterval: this.localRoute.notificationInterval
          })
        )
      );
      this.extended = false;
    },
    changeInterval(interval) {
      this.localRoute.notificationInterval = interval;
    },
    changeWochentag(wochentag) {
      this.localRoute.wochentage[wochentag] = !this.localRoute.wochentage[
        wochentag
      ];
    },
    checkTimeFormat() {
      this.localRoute.zeitVon = new Date(this.localRoute.zeitVon);
      this.localRoute.zeitBis = new Date(this.localRoute.zeitBis);
    }
  },
  watch: {
    route: function(newVal, oldVal) {
      this.route = newVal;
    },
    index: function(newVal, oldVal) {
      this.index = newVal;
    },
    extended: function(newVal, oldVal) {
      // JSONparse / JSONstringify um eine nested Copy von dem Objekt zu erhalten
      if (!newVal) this.localRoute = JSON.parse(JSON.stringify(this.route));
      this.checkTimeFormat();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wochentag {
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  padding: 5px;
  height: 36px;
  width: 36px;
}

.speichern {
  padding: 10px 5px;
}


.timepicker>table{
  width:20px;
  color: white;
  border:unset !important;
}
</style>
